import React from "react";
import { InputGroupText } from "reactstrap/esm/index.js";

export * from "reactstrap/esm/index.js";

export function InputGroupAddon({ addonType, children, className, tag: Tag, ...rest }) {
  if (!Tag && !className && Object.keys(rest).length === 0) {
    return <>{children}</>;
  }

  const Wrapper = Tag || "div";
  return (
    <Wrapper className={className} data-addon-type={addonType} {...rest}>
      {children}
    </Wrapper>
  );
}

export { InputGroupText };
